module.exports = __webpack_public_path__ + "static/media/17.ae72b213.JPG";